// import List from './List'
// import { inject, observer } from "mobx-react";
import React, { useState, useContext, useEffect } from 'react';
import {
  Button,
  Radio,
  RadioGroup,
  Input,
  Checkbox,
  Snackbar,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Select,
  TextField,
  MenuItem,
  Menu,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from './InspectorWalkaround.styles';
import addPhotoIcon from '../../../assets/images/addPhoto.png';
import { useDrag, useDrop } from 'react-dnd';
import { DND_TYPES } from '../../../enums';
import { InspectorOrderReviewContext } from '../InspectorOrderReviewContext/InspectorOrderReviewContext';
import MobilePhotoPicker from '../MobilePhotoPicker';
import ImageCarousel from '../../ImageCarousel';

const QUESTION_CONTAINER_HEIGHT = 60;
const QUESTION_IMAGE_HEIGHT = 50;
const DELETE_ICON_HEIGHT = 20;

const imageIsAttached = (question, src) =>
  question.answers &&
  question.answers.length &&
  question.answers[0].formFieldRepAnswerImage.findIndex(img => {
    // console.log([img.src, img.imageUri], src);
    // return [img.src, img.imageUri].find(uri => uri === src);
    return [img.src, img.imageUri].includes(src);
  }) !== -1;

const DndZone = ({ children, question, updateQuestion }) => {
  //   const black = (x + y) % 2 === 1;

  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept: DND_TYPES.IMAGE,
    drop: updateQuestion,
    collect: monitor => {
      const item = monitor.getItem();
      const canDrop = !imageIsAttached(question, item ? item.src : '');
      // console.log(item, canDrop);
      return item
        ? {
            isOver: !!monitor.isOver(),
            canDrop,
          }
        : {};
    },
  });

  return (
    <div
      ref={dropRef}
      className={cn(
        // 'flex-1',
        'row-start-center',
        // 'idk',
        // 'col-center-center',
        // 'align-stretch', // used for vertical orientation
      )}
      style={{
        // minWidth: '30%',
        // padding: isOver ? '12px -3px' : '15px 0',
        paddingTop: 15 + DELETE_ICON_HEIGHT / 2, // account for the delete icon so there is still equal space above and below the image
        paddingBottom: 15,
        // padding: '12px -3px',
        border: isOver ? '3px dashed #aaa' : '3px dashed #eee',
        // alignSelf: 'stretch',
        background: isOver ? (canDrop ? '#ddd' : 'rgba(255,0,0,0.2)') : 'transparent',

        // position: 'relative',
        // width: '100%',
        // height: '100%',
        // background: 'blue',
        height: QUESTION_IMAGE_HEIGHT,
        // minHeight: QUESTION_CONTAINER_HEIGHT,
        //   marginTop: 30,
        // border: '5px dashed #777',
        // display: 'flex',
        // flexDirection: 'row',
        // justifyContent: 'flex-start',
        // alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
};

const getPictureCount = question =>
  question.answers.reduce((acc, cur) => {
    return acc + (cur.formFieldRepAnswerImage ? cur.formFieldRepAnswerImage.length : 0);
  }, 0);

const getPictureCountLabel = question => {
  const count = getPictureCount(question);

  return count === 1 ? `(${count} photo)` : `(${count} photos)`;
};

const InspectorWalkaround = props => {
  const {
    classes,
    stepData: { questions, orderForms, goToNextStep, orderLineId },
    updateStepData,
    removeImageFromQuestion,
  } = props;

  const {
    state: { isSelfInspect, order, imagesWithQuestions },
    dispatch: reviewDispatch,
  } = useContext(InspectorOrderReviewContext);

  // const removeImageFromQuestion = (question, image) => {
  //   if (!question.answers || !question.answers[0].formFieldRepAnswerImage) {
  //     return;
  //   }

  //   // if not, add it and update step data
  //   question.answers[0].formFieldRepAnswerImage = question.answers[0].formFieldRepAnswerImage.filter(img => {
  //     // TODO.babyjay: refactor all images to use one src or imageUri so you don't need to do a double array search all the time
  //     const searchUris = [img.src, img.imageUri].filter(x => x); // filter out null/undefined values
  //     const removeUris = [image.src, image.imageUri].filter(x => x);

  //     const isMatch = searchUris.some(search => removeUris.includes(search));
  //     return !isMatch; // remove the match
  //   });

  //   updateStepData(question);
  // };

  const renderAttachedImage = (question, img) => (
    <div
      style={{
        position: 'relative',
        height: '100%',
      }}
    >
      <img
        src={img.src ? img.src : img.imageUri}
        style={{ width: 'auto', height: QUESTION_IMAGE_HEIGHT, marginRight: 20 }}
      />
      <span
        style={{
          position: 'absolute',
          top: -DELETE_ICON_HEIGHT / 2,
          right: DELETE_ICON_HEIGHT / 2,
          backgroundColor: 'rgba(255,0,0,0.8)',
          width: DELETE_ICON_HEIGHT,
          height: DELETE_ICON_HEIGHT,
          borderRadius: '50%',
          color: '#fff',
          fontFamily: '"Comic Sans MS", cursive, sans-serif',
          cursor: 'pointer',
          fontSize: 14,
        }}
        onClick={() => removeImageFromQuestion(question, img)}
      >
        X
      </span>
    </div>
  );

  const getQuestionLabel = questionLabel => {
    // determine if the question label has the generic words at the beginning
    const startsWithGenericLabel = questionLabel.includes('Take Photo:');

    // leave the label alone if it does not use that generic `Take Photo:` at the beginning
    if (!startsWithGenericLabel) {
      return questionLabel;
    }

    return questionLabel.split('Take Photo:')[1].trim();
  };

  const renderQuestion = (question, questionIndex) => {
    const updateQuestion = ({ type, ...image }) => {
      // check if image is already in this question's answers
      if (question.answers && question.answers.length) {
        // find the index of the answer and add it (if it does not exist yet)
        const answerImageIndex = question.answers[0].formFieldRepAnswerImage.findIndex(img =>
          [img.src, img.imageUri].includes(image.src),
        );

        // if the image was found, don't add it again
        if (answerImageIndex !== -1) return;

        // if not, add it and update step data
        question.answers[0].formFieldRepAnswerImage.push(image);
      } else {
        // use template if no answers exist
        var answerTemplate = {
          orderFormHeaderId: question.orderFormHeaderId,
          questionId: question.questionId,
          answerValueId: null,
          answerText: null,
          formFieldRepAnswerImage: [image],
        };

        question.answers.push(answerTemplate);
      }

      updateStepData(question);
    };

    const onAddImage = image => {
      //
      updateQuestion({ ...image });
    };

    // return (
    //   <div className={cn('flex-1', 'idk', 'col-center-center')} style={{ minWidth: '33%' }}>
    //     <img src={addPhotoIcon} style={{ maxWidth: 140, marginBottom: 15 }} />
    //     <span style={{ fontSize: '1.3rem' }}>{question.question.value.split('Take Photo:')[1].trim()}</span>
    //   </div>
    // );

 console.log(question);
console.log(orderForms);
    const images = question.answers.map(ans => ans.formFieldRepAnswerImage).flat();
    const formHeaderName = orderForms.find(of => of.orderFormHeaderId === question.orderFormHeaderId).formHeaderName;
    return (
      <React.Fragment>
        <div className={cn('row-start-center')} style={{ marginTop: 10 }}>
          <span style={{ fontSize: '1.1rem', color: '#555', marginRight: 5 }}>
            {getQuestionLabel(question.question.value)} ({formHeaderName})
            {/* {question.question.value.split('Take Photo:')[1].trim()} */}
          </span>
          <span style={{ color: '#777', fontSize: '1.1rem' }}> - {getPictureCountLabel(question)}</span>
        </div>

        {isSelfInspect ? (
          <div className="row-start-center">
            <MobilePhotoPicker
              question={question}
              // answerTriggerIndex={answerTriggerIndex}
              // imageRequired={imageRequired}
              onAddImage={onAddImage}
              images={images}
              imageIsAttached={imageIsAttached}
              removeImageFromQuestion={removeImageFromQuestion}
              iconStyle={{
                color: images.length ? 'var(--jmi-blue)' : 'var(--jmi-red)',
                marginRight: 20,
              }}
            />

            <ImageCarousel
              renderPlaceholder={'No photos attached yet'}
              images={images}
              height={100}
              containerOffset={17 + 24} // 17 for padding + 24 for icon width
              containerStyle={{
                border: '1px dotted gray',
                borderRadius: 5,
              }}
              debug={!questionIndex}
            />
          </div>
        ) : (
          <DndZone question={question} updateStepData={updateStepData} updateQuestion={updateQuestion}>
            {/* show the pictures */}
            <div className={cn('row-start-center', 'align-stretch')} style={{ marginLeft: 10 }}>
              {question.answers.map(ans => ans.formFieldRepAnswerImage.map(img => renderAttachedImage(question, img)))}
              {/* {!getPictureCount(question) && <span style={{ color: '#777' }}>Drag an image here to attach it!</span>} */}
            </div>

            {!getPictureCount(question) && (
              <div className={cn('row-center-center', 'align-stretch', 'flex-1')} style={{ marginLeft: 10 }}>
                <img
                  src={addPhotoIcon}
                  style={{
                    width: 'auto',
                    height: QUESTION_IMAGE_HEIGHT,
                    marginLeft: 10,
                    paddingRight: 20,
                    borderRight: '2px solid #bbb',
                  }}
                />
                <span style={{ color: '#BBB', fontSize: '1.5rem', marginLeft: 20 }}>
                  Drag an image here to attach it!
                </span>
              </div>
            )}
          </DndZone>
        )}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className={cn('flex-1', 'flex-column', 'px-20')}>
        {/*  */}
        {questions.map(q => renderQuestion(q))}
      </div>
    </React.Fragment>
  );
};

InspectorWalkaround.propTypes = {
  stepData: PropTypes.shape({
    formContext: PropTypes.string.isRequired,
    orderForms: PropTypes.arrayOf(PropTypes.object).isRequired,
    goToNextStep: PropTypes.func.isRequired,
    orderLineId: PropTypes.any.isRequired,
    // questions: PropTypes.array.isRequired,
    // useSnack: PropTypes.bool,
  }),
};

InspectorWalkaround.defaultProps = {
  // useSnack: true,
};

export default withStyles(styles)(InspectorWalkaround);
